import moment from 'moment'

export const dec = v => {
	if (v == null) return 0
	if (typeof v === 'object' && v.$numberDecimal !== undefined) {
		const n = Number(v.$numberDecimal)
		return Number.isFinite(n) ? n : 0
	}
	const n = Number(v)
	return Number.isFinite(n) ? n : 0
}

export const toYMD = d => {
	if (!d) return ''
	const m = moment(d)
	if (!m.isValid()) return ''
	return m.format('YYYY-MM-DD')
}

export const deriveStatus = inv => {
	if (!inv) return 'issued'
	if (inv.status) return inv.status
	if (inv.paidDate) return 'paid'
	if (inv.paymentTerm && moment().isAfter(moment(inv.paymentTerm))) return 'overdue'
	return 'issued'
}

const mapLine = (line = {}, fallback = {}) => ({
	price: dec(line.price ?? fallback.price),
	count: dec(line.count ?? fallback.count) || 0,
	taxPercent: dec(line.taxPercent ?? fallback.taxPercent),
	subtotal: dec(line.subtotal ?? fallback.subtotal),
	taxValue: dec(line.taxValue ?? fallback.taxValue),
	total: dec(line.total ?? fallback.total),
})

export const buildFormFromInvoice = data => {
	const products = Array.isArray(data.products) && data.products.length
		? data.products.map(p => {
				const legacy = {
					price: dec(p.price),
					count: dec(p.count) || 1,
					taxPercent: dec(p.taxPercent),
					subtotal: dec(p.subtotal),
					taxValue: dec(p.taxValue),
					total: dec(p.total),
				}
				return {
					name: p.name || '',
					sku: p.sku || '',
					article_number: p.article_number || '',
					productId: (p.productId?._id || p.productId || '').toString(),
					productName: p.productName || '',
					before: mapLine(p.before, legacy),
					after: mapLine(p.after, p.before || legacy),
				}
			})
		: []

	return {
		customerId: (data.customerId?._id || data.customerId || '').toString(),
		customerName: data.customerName || data.customerId?.name || '',
		invoiceNumber: data.number || '',
		correctedInvoiceNumber: data.correctedInvoiceNumber || '',
		sourceInvoiceId: (data.sourceInvoiceId?._id || data.sourceInvoiceId || '').toString(),
		correctionReason: data.correctionReason || '',
		invoiceDate: toYMD(data.invoiceDate || data.date),
		discountPercent: String(dec(data.discountPercent ?? data.discount) || 0),
		publicNotes: data.publicNotes || '',
		privateNotes: data.privateNotes || '',
		paymentType: data.paymentType || 'transfer',
		paymentDate: toYMD(data.paidDate),
		products,
		dueDate: toYMD(data.dueDate || data.paymentTerm),
		status: deriveStatus(data),
		subtotal: dec(data.subtotal || 0),
		taxTotal: dec(data.taxTotal || 0),
		total: dec(data.total || 0),
		discountValue: dec(data.discountValue || 0),
		companyId: data.companyId || '',
		companyName: data.companyName || '',
	}
}
